import { __decorate } from "tslib";
import { html } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import { addStyleSheetToElements } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/utils/cssstylesheet-interface.js';
import styles from './footer.scss.js';
import listStyles from './list.scss.js';
import groupStyles from './group.scss.js';
import groupLinkStyles from './group-links.scss.js';
import linkStyles from './links.scss.js';
import footertopStyles from './footer-top.scss.js';
/**
 * @returns Footer component.
 */
export class Footer extends CipublicElement {
    constructor() {
        super(...arguments);
        this.hideFooterTop = false;
    }
    static get styles() {
        return [styles];
    }
    async firstUpdated(changedProperties) {
        super.firstUpdated(changedProperties);
        const listElements = this.querySelectorAll('cipublic-list');
        addStyleSheetToElements(listElements, listStyles);
        const groupElements = this.querySelectorAll('cipublic-group');
        addStyleSheetToElements(groupElements, groupStyles);
        const groupLinks = this.querySelectorAll('cipublic-group cipublic-link');
        addStyleSheetToElements(groupLinks, groupLinkStyles);
        const footerLinks = [...this.querySelectorAll('*')].filter((element) => element.nodeName === 'CIPUBLIC-LINK');
        const footerLists = [...this.querySelectorAll('*')].filter((element) => element.nodeName === 'CIPUBLIC-LIST');
        footerLists.forEach((linkList) => { var _a; return (_a = linkList.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('cipublic-link').forEach((link) => footerLinks.push(link)); });
        addStyleSheetToElements(footerLinks, linkStyles);
    }
    render() {
        return html `<footer><slot name="heading"></slot>${!this.hideFooterTop
            ? html `<section class="footer-top"><div class="footer-top-content"><slot name="top" @slotchange="${(event) => {
                const slotElements = event.target.assignedElements()[0].querySelectorAll('cipublic-list');
                addStyleSheetToElements(slotElements, footertopStyles);
            }}"></slot></div></section>`
            : ''}<section class="footer-bottom"><div class="footer-bottom-content"><slot name="copyright"></slot><slot name="legal-links"></slot><hr><slot name="disclaimer"></slot></div></section></footer>`;
    }
}
__decorate([
    property({ type: Boolean })
], Footer.prototype, "hideFooterTop", void 0);
//# sourceMappingURL=footer.js.map